import { Assort } from "./../../../models/Assort";
import { Exercise } from "./../../../models/Exercise";
import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_EVENTS, GET_TICKETS_EVENT } from "../../../api/apiRoutes";
import { setTicketAccessFromExercise, TicketAccess } from "../../../models/TicketAccess";

export default function useEvents() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [exercise, setExercise] = useState<Exercise[]>([]);
  const [ticketAccess, setTicketAccess] = useState<TicketAccess>({} as TicketAccess);
  const [loading, setLoading] = useState(false);

  const [tickets, setTickets] = useState<Assort[]>([]);

  const getEventExercises = async (exerciseName?: string, exerciseIds?: string, exerciseGroupIds?: string) => {
    const requestGetAssortGroups = async () => {
      setLoading(true);
      const { result, isError } = await get(GET_EVENTS(facilityIds, exerciseName, exerciseIds, exerciseGroupIds));
      if (!isError) {
        if (result.length > 0) {
          setExercise(result);
        }
      }
      setLoading(false);
    };
    requestGetAssortGroups();
  };

  const formatTicketAccess = async (item: Exercise) => {
    let ticketAccessTransform = setTicketAccessFromExercise(item.objectId, item.name, item.startTime);
    setTicketAccess(ticketAccessTransform);
  };

  const getTicketsForEvent = async (objectDd: number, objectId: number) => {
    const ids = `${objectDd},${objectId}`;
    const { result, isError } = await get(GET_TICKETS_EVENT(facilityIds, ids));
    if (!isError) {
      setTickets(result);
    }
  };

  return {
    getEventExercises,
    formatTicketAccess,
    getTicketsForEvent,
    exercise,
    tickets,
    ticketAccess,
    loading,
  };
}
